import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { Modal, Button, Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import closeIcon from "../../../common/assets/images/x-close.png";

import {
  updateFilters,
  getAuditorViewData,
  getLOSOptions,
  getSpecialityFilterOptions,
  setSpecialityFilterSearch,
  getQueueFilterOptions,
  setQueueFilterSearch,
  getStatusFilterOptions,
  setStatusFilterSearch,
  getPriorityFilterOptions,
  setPriorityFilterSearch,
  resetAuditorFilters,
  resetEpisodeIdsAuditorData,
  getAuditorViewCardData,
} from "./redux/AuditorViewSlicer";

import "./AuditorFilterModal.css";
import {
  getEpisodeIdentiferFilterOptions,
  getMRNFilterOptions,
  getHealthFundContractFilterOptions,
  getProvisionalDrgFilterOptions,
  setEpisodeIdentiferFilterSearch,
  setMRNFilterSearch,
  setHealthFundFilterContractSearch,
  setProvisionalDrgFilterSearch,
  resetFilterByKey,
} from "../HealthInsuranceManager/redux/HealthInformationManagerSlicer";
import MultiSelect from "../../../utils/MultiSelect";
import { debounce } from "lodash";
const AuditorFilterModal = ({
  show,
  setShowAuditorFilter,
  onClose,
  setCoderSearchTerm,
}) => {
  const dispatch = useDispatch();

  const filtersPayload = useSelector(
    (state) => state.auditorView.auditorViewEpisodesPayload,
  );

  const {
    episodeIdentiferFilterOptions,
    MRNFilterOptions,
    healthFundContractFilterOptions,
    provisionalDrgFilterOptions,
  } = useSelector((state) => state.healthInsuranceManager);

  const {
    specialityFilterOptions,
    queueFilterOptions,
    priorityFilterOptions,
    statusFilterOptions,
  } = useSelector((state) => state.auditorView);

  const healthFund = useSelector((state) => state.auditorView.healthFund);
  // const newHealthFundData = useSelector(
  //   (state) => state.auditorView.healthFund.healthFundData,
  // );
  const [losOptions, setLosOptions] = useState([]);
  const [hasMoreLos, setHasMoreLos] = useState(false);
  const [losOperator, setLosOperator] = useState("");
  const [losValue, setLosValue] = useState("");
  const [losToValue, setLosToValue] = useState("");
  const [isLosEnabled, setIsLosEnabled] = useState(false);
  const [losMode, setLosMode] = useState("single");
  const [isCodeEnhanceSelected, setIsCodeEnhanceSelected] = useState(false);
  const [firstQueueTypeWhenUnassigned, setFirstQueueTypeWhenUnassigned] =
    useState(null);

  const {
    losData = [],
    losLoading,
    isLosPageTrue,
    losPageNumber = 0,
  } = useSelector((state) => state.auditorView.losOptions);

  useEffect(() => {
    if (filtersPayload.los_op === null && losOperator) {
      setLosOperator("");
      setLosValue("");
      setLosToValue("");
      setIsLosEnabled(false);
    }
  }, [filtersPayload.los_op]);

  const getLosBreadcrumbText = (operator, value, toValue = "") => {
    const operatorText = losOpLabelMap[operator] || operator;
    const valueText = value === "no_los" ? "No LOS" : `${value} days`;

    if (operator === "gtlt" || operator === "gtelte") {
      const toValueText = toValue === "no_los" ? "No LOS" : `${toValue} days`;
      return `${operatorText} ${valueText} and ${toValueText}`;
    } else {
      return `${operatorText} ${valueText}`;
    }
  };

  useEffect(() => {
    if (show) {
      dispatch(getLOSOptions(1));
      dispatch(
        getEpisodeIdentiferFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );

      dispatch(
        getMRNFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );

      dispatch(
        getSpecialityFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getQueueFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getPriorityFilterOptions({
          queues: filtersPayload.queue || [],
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getStatusFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getHealthFundContractFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getProvisionalDrgFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }
  }, [show, dispatch]);

  const episodeIdentiferFieldOptions = useMemo(() => {
    const apiOptions = (episodeIdentiferFilterOptions.data || []).map(
      (item) => ({
        label: item,
        value: item,
      }),
    );

    const episode_identifier_search = [].concat(
      filtersPayload?.episode_identifier_search || [],
    );

    const selectedOptions = episode_identifier_search.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [
    episodeIdentiferFilterOptions.data,
    filtersPayload?.episode_identifier_search,
  ]);

  const MRNFieldOptions = useMemo(() => {
    const apiOptions = (MRNFilterOptions.data || []).map((item) => ({
      label: item,
      value: item,
    }));

    const medical_record_number = [].concat(
      filtersPayload?.medical_record_number || [],
    );

    const selectedOptions = medical_record_number.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [MRNFilterOptions.data, filtersPayload?.medical_record_number]);

  const labelCache = useRef({});
  const statusLabelCache = useRef({});

  const specialityFieldOptions = useMemo(() => {
    const apiOptions = (specialityFilterOptions.data || []).map((item) => {
      // ✅ store label
      labelCache.current[item.hospital_speciality_id] = item.speciality;

      return {
        label: item.speciality,
        value: item.hospital_speciality_id,
      };
    });

    const selectedOptions = (filtersPayload.speciality || []).map((value) => {
      return {
        value,
        label: labelCache.current[value] || value,
      };
    });

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [specialityFilterOptions.data, filtersPayload.speciality]);

  const queueFieldOptions = useMemo(() => {
    const apiOptions = queueFilterOptions.data.map((item) => ({
      label: item?.queue_name,
      value: item?.queue_id,
    }));

    const selectedOptions = (filtersPayload.queue || []).map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [queueFilterOptions.data, filtersPayload.queue]);

  const priorityFiledOptions = useMemo(() => {
    const apiOptions = priorityFilterOptions.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = filtersPayload?.priority?.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [priorityFilterOptions.data, filtersPayload?.priority]);

  //   const statusFiledOptions = useMemo(() => {
  //   const apiOptions = statusFilterOptions.data.map((item) => ({
  //   label: item.status,
  //   value: item.status_id,
  // }));

  //     const selectedOptions = (filtersPayload?.status || []).map((value) => {
  //   const match = statusFilterOptions.data.find(
  //     (item) => item.status_id === value
  //   );

  //   return match
  //     ? { label: match.status, value: match.status_id }
  //     : null;
  // }).filter(Boolean);

  //     const map = new Map();

  //     [...selectedOptions, ...apiOptions].forEach((item) => {
  //       map.set(item.value, item);
  //     });

  //     return Array.from(map.values());
  //   }, [statusFilterOptions.data, filtersPayload?.status]);
  const statusFiledOptions = useMemo(() => {
    const apiOptions = (statusFilterOptions.data || []).map((item) => {
      // ✅ store label in cache
      statusLabelCache.current[item.status_id] = item.status;

      return {
        label: item.status,
        value: item.status_id,
      };
    });

    const selectedOptions = (filtersPayload?.status || []).map((value) => {
      return {
        value,
        label: statusLabelCache.current[value] || value, // ✅ fallback handled
      };
    });

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [statusFilterOptions.data, filtersPayload?.status]);
  const healthFundFieldOptions = useMemo(() => {
    const apiOptions = healthFundContractFilterOptions.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = filtersPayload?.health_fund_contract?.map(
      (value) => ({
        label: value,
        value: value,
      }),
    );

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [
    healthFundContractFilterOptions.data,
    filtersPayload?.health_fund_contract,
  ]);

  const provisionalDrgFieldOptions = useMemo(() => {
    const apiOptions = provisionalDrgFilterOptions.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = filtersPayload?.drg_code?.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [provisionalDrgFilterOptions.data, filtersPayload?.drg_code]);

  const debouncedSearchRef = useRef(
    debounce((thunk, value) => {
      dispatch(
        thunk({
          search: value || "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }, 1000),
  );

  const handleInputChange =
    (setSearchAction, fetchThunk) =>
    (value, { action }) => {
      if (action !== "input-change") {
        return;
      }
      dispatch(setSearchAction(value));
      debouncedSearchRef.current(fetchThunk, value);
    };

  const handleScrollBottom = (options, thunk) => () => {
    if (options.hasMore && !options.loading) {
      dispatch(
        thunk({
          search: options.search || "",
          page_number: options.pageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleOnFocus = (optionsState, fetchThunk) => {
    if (optionsState?.data?.length === 0 && !optionsState.loading) {
      dispatch(
        fetchThunk({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }
  };

  const isUserSpecific = filtersPayload.is_user_specific ?? true;
  const isQueueDisabled = isUserSpecific === true;

  const LIMITED_STATUS = ["Outstanding", "AI codes awaiting validation"];

  const filteredStatusOptions =
    isUserSpecific === false
      ? statusFiledOptions.filter((s) => LIMITED_STATUS.includes(s.label))
      : statusFiledOptions;

  const userSpecificOptions = [
    { label: "True", value: true },
    { label: "False", value: false },
  ];

  const handleOnChange = async ({
    key,
    selected,
    optionsState,
    fetchThunk,
    searchResetAction,
    minVisible = 4,
  }) => {
    const selectedArray = selected || [];

    const selectedValues =
      key === "speciality" || key === "queue" || key === "status"
        ? selectedArray.map((s) => s.value)
        : selectedArray.map((s) => s.label);

    dispatch(updateFilters({ [key]: selectedValues }));
    // const selectedQueues = selectedValues.map((id) =>
    //   queueFilterOptions?.data?.find((queue) => queue?.queue_id === id)
    // );
    // const getSelectedQueueNames = selectedQueues?.map((queue) => queue?.queue_name)

    if (key === "queue") {
      dispatch(
        getPriorityFilterOptions({
          queues: selectedValues || [],
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }

    if (optionsState.search) {
      dispatch(searchResetAction(""));
      debouncedSearchRef.current?.cancel?.();

      let currentPage = 1;
      let hasMore = true;
      let accumulatedData = [];

      while (hasMore) {
        const response = await dispatch(
          fetchThunk({
            search: "",
            page_number: currentPage,
            page_size: 10,
          }),
        ).unwrap();

        const dataMap = {
          episode_identifier_search: response.episode_identifier_number,
          medical_record_number: response.medical_record_number,
          speciality: response?.specialities,
          queue: response?.queue?.data,
          queue_priority: response?.priority,
          status: response?.status,
          health_fund_contract: response?.health_funds,
          drg_code: response?.drg_codes,
        };

        const pageData = dataMap[key] || [];
        accumulatedData = [...accumulatedData, ...pageData];
        hasMore = response.has_more;
        const visibleOptions = accumulatedData.filter((item) => {
          const compareValue =
            key === "speciality" || key === "queue" || key === "status"
              ? item.value
              : item;

          return !selectedValues.includes(compareValue);
        });

        if (visibleOptions.length >= minVisible) break;
        if (!hasMore) break;

        currentPage += 1;
      }
      return;
    }
    const visibleOptions = optionsState.data.filter((item) => {
      let compareValue;

      if (typeof item === "object") {
        if (key === "speciality") {
          compareValue = item.hospital_speciality_id;
        } else if (key === "queue") {
          compareValue = item.queue_id;
        } else if (key === "status") {
          compareValue = item.status_id;
        } else {
          compareValue = item.value || item.label;
        }
      } else {
        compareValue = item;
      }

      return !selectedValues.includes(compareValue);
    });

    if (
      visibleOptions.length < minVisible &&
      optionsState.hasMore &&
      !optionsState.loading
    ) {
      dispatch(
        fetchThunk({
          search: "",
          page_number: optionsState.pageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleResetOnBlur = (stateKey, searchResetAction) => () => {
    debouncedSearchRef.current?.cancel?.();
    dispatch(searchResetAction(""));
    if (
      stateKey === "specialityFilterOptions" ||
      stateKey === "queueFilterOptions" ||
      stateKey === "statusFilterOptions"
    ) {
      dispatch(resetEpisodeIdsAuditorData(stateKey));
    } else {
      dispatch(resetFilterByKey(stateKey));
    }
  };

  useEffect(() => {
    const selectedQueues = filtersPayload.queue
      .map((id) =>
        queueFilterOptions?.data?.find((queue) => queue.queue_id === id),
      )
      .filter(Boolean);

    const queueNames = selectedQueues.map((queue) => queue.queue_name);

    const hasCodeEnhance = queueNames.some((name) => name === "Code Enhance");

    const hasOtherQueues = queueNames.some((name) => !name === "Code Enhance");

    setIsCodeEnhanceSelected(hasCodeEnhance);

    if (filtersPayload.queue.length === 0) {
      setFirstQueueTypeWhenUnassigned(null);
    }

    if (filtersPayload.unassigned === true) {
      if (hasCodeEnhance && hasOtherQueues) {
        let queueTypeToKeep = firstQueueTypeWhenUnassigned;

        if (!queueTypeToKeep) {
          const firstSelectedQueue = filtersPayload.queue[0];
          const isFirstQueueCodeEnhance = queueNames.some(
            (name) => name === "Code Enhance",
          );
          queueTypeToKeep = isFirstQueueCodeEnhance ? "code-enhance" : "other";
          setFirstQueueTypeWhenUnassigned(queueTypeToKeep);
        }

        const filteredQueues = filtersPayload.queue.filter((queueName) => {
          const isCodeEnhance = queueNames.some(
            (name) => name === "Code Enhance",
          );

          return queueTypeToKeep === "code-enhance"
            ? isCodeEnhance
            : !isCodeEnhance;
        });

        const message =
          queueTypeToKeep === "code-enhance"
            ? "When 'Unassigned: True' is selected with 'Code Enhance', other queues are removed."
            : "When 'Unassigned: True' is selected with non-Code Enhance queues, 'Code Enhance' is removed.";

        toast.warning(message, {
          autoClose: 3000,
          position: "top-right",
        });

        dispatch(updateFilters({ queue: filteredQueues }));
      } else if (filtersPayload.queue.length > 0) {
        const queueType = filtersPayload.queue.some(
          (q) => q === queueNames.some((name) => name === "Code Enhance"),
        )
          ? "code-enhance"
          : "other";
        setFirstQueueTypeWhenUnassigned(queueType);
      }
    } else {
      setFirstQueueTypeWhenUnassigned(null);
    }
  }, [
    filtersPayload.queue,
    filtersPayload.unassigned,
    dispatch,
    firstQueueTypeWhenUnassigned,
  ]);

  useEffect(() => {
    if (losData && losData.length > 0) {

      const processedOptions = losData.map((los) => {
        if (los === null) {
          return {
            label: "No LOS",
            value: "no_los",
            originalValue: null,
            displayLabel: "No LOS",
          };
        }
        return {
          label: `${los} days`,
          value: los.toString(),
          originalValue: los,
          displayLabel: `${los} days`,
        };
      });

      const uniqueOptions = processedOptions.reduce((acc, current) => {
        const exists = acc.find((item) => item.value === current.value);
        if (!exists) {
          acc.push(current);
        }
        return acc;
      }, []);

      uniqueOptions.sort((a, b) => {
        if (a.value === "no_los") return -1;
        if (b.value === "no_los") return 1;
        return parseInt(a.value) - parseInt(b.value);
      });

      setLosOptions(uniqueOptions);
      setHasMoreLos(isLosPageTrue || false);

    } else if (losData && losData.length === 0) {
      setLosOptions([]);
      setHasMoreLos(false);
    }
  }, [losData, isLosPageTrue]);

  const loadMoreLosOptions = useCallback(() => {
    if (hasMoreLos && !losLoading) {
      const nextPage = losPageNumber + 1;
      dispatch(getLOSOptions(nextPage));
    }
  }, [hasMoreLos, losLoading, losPageNumber, dispatch]);
  const handleLosOperatorChange = (selected) => {
    const operator = selected?.value || "";

    setLosOperator(operator);
    setIsLosEnabled(!!operator);

    dispatch(updateFilters({ los_op: operator || null }));

    if (operator === "gtlt" || operator === "gtelte") {
      setLosMode("range");
    } else {
      setLosMode("single");
    }
  };

  const handleLosChange = (selected) => {
    const value = selected ? selected.value : "";
    setLosValue(value);
    const hasNoLos = value === "no_los";
    dispatch(
      updateFilters({
        los: value && value !== "no_los" ? [Number(value)] : [],
        no_los: hasNoLos,
        page_number: 1,
      }),
    );
  };

  const handleLosToChange = (selected) => {
    const value = selected ? selected.value : "";
    setLosToValue(value);
  };

  const LosSelect = ({
    value,
    onChange,
    placeholder = "Select LOS",
    isDisabled = false,
    isRangeTo = false,
  }) => {
    const selectedValue = React.useMemo(() => {
      if (value === null)
        return losOptions.find((opt) => opt.value === "no_los");
      if (value === undefined || value === "") return null;
      return losOptions.find((opt) => opt.value === value.toString());
    }, [value, losOptions]);

    const selectOptions = React.useMemo(() => {
      return losOptions.map((option) => ({
        label: option.displayLabel,
        value: option.value,
        originalValue: option.originalValue,
      }));
    }, [losOptions]);

    const handleScrollToBottom = useCallback(() => {
      loadMoreLosOptions();
    }, [loadMoreLosOptions]);

    return (
      <Select
        options={selectOptions}
        value={selectedValue}
        onChange={onChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isLoading={losLoading}
        loadingMessage={() => "Loading LOS options..."}
        onMenuScrollToBottom={handleScrollToBottom}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            maxHeight: "250px", // Force scrollbar for pagination
          }),
          control: (base) => ({
            ...base,
            minHeight: "38px",
            borderColor: "#cfd6e4",
            backgroundColor: isDisabled ? "#f3f4f6" : "white",
            opacity: isDisabled ? 0.7 : 1,
          }),
          option: (base) => ({
            ...base,
            fontSize: "14px",
            padding: "8px 12px",
          }),
        }}
        filterOption={(option, inputValue) => {
          // Custom filtering for "No LOS"
          if (option.data.originalValue === null) {
            return "no los".includes(inputValue.toLowerCase());
          }
          return option.label.toLowerCase().includes(inputValue.toLowerCase());
        }}
        noOptionsMessage={({ inputValue }) =>
          inputValue
            ? "No matching LOS found"
            : losLoading
              ? "Loading..."
              : "No LOS options available"
        }
      />
    );
  };

  const unassignedOptions = [
    { label: "True", value: true },
    { label: "False", value: false },
  ];

  const losOperatorOptions = [
    { label: ">", value: "gt" },
    { label: "<", value: "lt" },
    { label: ">=", value: "gte" },
    { label: "<=", value: "lte" },
    { label: "=", value: "eq" },
    { label: "!=", value: "neq" },
    { label: "Between", value: "gtlt" },
    { label: "Between (Inclusive)", value: "gtelte" },
  ];

  const losOpLabelMap = {
    gt: ">",
    lt: "<",
    gte: ">=",
    lte: "<=",
    eq: "=",
    neq: "!=",
    gtlt: "Between",
    gtelte: "Between (Inclusive)",
  };

  const breadcrumbExcludeKeys = [
    "page_number",
    "page_size",
    "queue_page_number",
  ];

  const labelMaps = {
    episode_identifer: episodeIdentiferFieldOptions,
    speciality: specialityFieldOptions,
    queue: queueFieldOptions,
    priority: priorityFiledOptions,
    status: filteredStatusOptions,
    medical_record_number: MRNFieldOptions,
    health_fund_contract: healthFundFieldOptions,
    unassigned: unassignedOptions,
    drg_code: provisionalDrgFieldOptions,
  };

  const getLabel = (key, value) => {
    if (key === "no_mrn" && value === true) {
      return "No MRN";
    }
    if (key === "no_priority" && value === true) {
      return "No Priority";
    }
    if (key === "no_los" && value === true) {
      return "No LOS";
    }
    if (key === "los_op") {
      return losOpLabelMap[value] || value;
    }
    if (key === "medical_record_number") {
      if (value === "No_mrn" || value === "no_mrn" || value === null) {
        return "No MRN";
      }
      return value;
    }
    if (key === "los" || key === "los_to") {
      return value === null ? "No LOS" : `${value} days`;
    }
    //   if (key === 'los' || key === 'los_to') {
    //   if (value === 'no_los' || value === 'No_los' || value === null) {
    //     return 'No LOS';
    //   }
    //   return value === null ? 'No LOS' : `${value} days`;
    // }
    if (key === "los_op") {
      return losOpLabelMap[value] || value;
    }
    if (key === "health_fund_contract") {
      // Health funds are simple strings, so return as-is
      return value;
    }
    if (key === "unassigned") {
      return value === true ? "True" : "False";
    }
    return labelMaps[key]?.find((o) => o.value === value)?.label || value;
  };

  const hasValue = Object?.entries(filtersPayload)?.some(
    ([key, val]) =>
      !breadcrumbExcludeKeys?.includes(key) &&
      (Array.isArray(val) ? val?.length > 0 : !!val),
  );

  //Formate date payload
  const formatYYYYMMDD = (d) =>
    d
      ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
          2,
          "0",
        )}-${String(d.getDate()).padStart(2, "0")}`
      : null;

  //format date bread crumb
  const formatDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const [y, m, d] = dateStr.split("-");
    return `${d}/${m}/${y}`;
  };

  const handleApply = () => {
    const payload = {
      page_number: 1,
      page_size: 10,
      // REMOVED: unassigned: filtersPayload.unassigned || false,
      separation_date_from: filtersPayload.separation_date_from,
      separation_date_to: filtersPayload.separation_date_to,
      admission_date_from: filtersPayload.admission_date_from,
      admission_date_to: filtersPayload.admission_date_to,
      health_fund_contract: filtersPayload.health_fund_contract || [],
      queue: filtersPayload.queue || [],
      speciality: filtersPayload.speciality || [],
      status: (filtersPayload.status || []).map((s) =>
        typeof s === "object" ? s.status_id : s,
      ),
      episode_identifier_search: filtersPayload.episode_identifier_search || "",
      medical_record_number: filtersPayload.medical_record_number,
      priority: filtersPayload.priority,
      los: transformLosForApi(
        filtersPayload.los_op,
        filtersPayload.los?.[0],
        filtersPayload.los?.[1],
      ),
      drg_code: filtersPayload.drg_code,
      // LOS operator
      los_op: losOperator || null,
       is_user_specific: filtersPayload.is_user_specific,
       is_global_search: false,
    };

    // onClose();
    setShowAuditorFilter(false);
    dispatch(getAuditorViewCardData(payload));
    dispatch(getAuditorViewData(payload));
    dispatch(updateFilters(payload));
    setCoderSearchTerm("");
  };

  const transformLosForApi = (operator, value, toValue = "") => {
    const los = [];

    if (!operator || value === "" || value === undefined) return [];

    const losValue =
      value === "no_los" || value === null ? "No_los" : Number(value);

    const isRange = operator === "gtlt" || operator === "gtelte";

    if (isRange) {
      if (toValue === "") return [];
      const losToValue =
        toValue === "no_los" || toValue === null ? "No_los" : Number(toValue);
      los.push(losValue, losToValue);
    } else {
      los.push(losValue);
    }
    return los;
  };

  const handleReset = () => {
    setLosOperator("");
    setLosValue("");
    setLosToValue("");
    setIsLosEnabled(false);
    setLosMode("single");
    setFirstQueueTypeWhenUnassigned(null); // Clear stored queue type
    dispatch(resetAuditorFilters());
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      dialogClassName="modal-xl"
    >
      <Modal.Header closeButton className="episode-list-modal-header">
        <Modal.Title className="episode-list-filter-modal-title">
          Auditor Workspace Filters
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {hasValue && (
          <div className="episodelist-filter-breadcrumb-section">
            <div className="episodelist-breadcrumb-list">
              {/* Array-based filters */}
              {Object.entries(filtersPayload)
                .filter(
                  ([key, val]) =>
                    !breadcrumbExcludeKeys.includes(key) &&
                    Array.isArray(val) &&
                    val.length > 0,
                )
                .map(([key, value]) =>
                  value.map((item) => (
                    <Badge
                      key={`${key}-${item}`}
                      bg="light"
                      text="dark"
                      className="episodeListFilterObj-breadcrumbItem"
                    >
                      <span className="breadcrumb-text">
                        {key.replace(/_/g, " ")} : {getLabel(key, item)}
                      </span>
                      <img
                        src={closeIcon}
                        alt="remove"
                        className="episodeListFilterObj-close-icon"
                        onClick={() =>
                          dispatch(
                            updateFilters({
                              [key]: value.filter((v) => v !== item),
                            }),
                          )
                        }
                      />
                    </Badge>
                  )),
                )}

              {filtersPayload.no_mrn && (
                <Badge
                  bg="light"
                  text="dark"
                  className="episodeListFilterObj-breadcrumbItem"
                >
                  <span className="breadcrumb-text">UR Number : No MRN</span>
                  <img
                    src={closeIcon}
                    alt="remove"
                    className="episodeListFilterObj-close-icon"
                    onClick={() => dispatch(updateFilters({ no_mrn: false }))}
                  />
                </Badge>
              )}

              {filtersPayload.no_priority && (
                <Badge
                  bg="light"
                  text="dark"
                  className="episodeListFilterObj-breadcrumbItem"
                >
                  <span className="breadcrumb-text">
                    Priority : No Priority
                  </span>
                  <img
                    src={closeIcon}
                    alt="remove"
                    className="episodeListFilterObj-close-icon"
                    onClick={() =>
                      dispatch(updateFilters({ no_priority: false }))
                    }
                  />
                </Badge>
              )}

              {filtersPayload.no_los && (
                <Badge
                  bg="light"
                  text="dark"
                  className="episodeListFilterObj-breadcrumbItem"
                >
                  <span className="breadcrumb-text">
                    Length of Stay : No LOS
                  </span>
                  <img
                    src={closeIcon}
                    alt="remove"
                    className="episodeListFilterObj-close-icon"
                    onClick={() => {
                      dispatch(updateFilters({ no_los: false }));
                      setLosValue("");
                    }}
                  />
                </Badge>
              )}
              {/* Admission from */}
              {filtersPayload.admission_date_from && (
                <Badge
                  bg="light"
                  text="dark"
                  className="episodeListFilterObj-breadcrumbItem"
                >
                  <span className="breadcrumb-text">
                    Admission From Date :{" "}
                    {formatDDMMYYYY(filtersPayload.admission_date_from)}
                  </span>
                  <img
                    src={closeIcon}
                    alt="remove"
                    className="episodeListFilterObj-close-icon"
                    onClick={() =>
                      dispatch(updateFilters({ admission_date_from: null }))
                    }
                  />
                </Badge>
              )}
              {/* Admission to */}
              {filtersPayload.admission_date_to && (
                <Badge
                  bg="light"
                  text="dark"
                  className="episodeListFilterObj-breadcrumbItem"
                >
                  <span className="breadcrumb-text">
                    Admission To Date :{" "}
                    {formatDDMMYYYY(filtersPayload.admission_date_to)}
                  </span>
                  <img
                    src={closeIcon}
                    alt="remove"
                    className="episodeListFilterObj-close-icon"
                    onClick={() =>
                      dispatch(updateFilters({ admission_date_to: null }))
                    }
                  />
                </Badge>
              )}

              {/* Separation Date From */}
              {filtersPayload.separation_date_from && (
                <Badge
                  bg="light"
                  text="dark"
                  className="episodeListFilterObj-breadcrumbItem"
                >
                  <span className="breadcrumb-text">
                    Seperation From Date :{" "}
                    {formatDDMMYYYY(filtersPayload.separation_date_from)}
                  </span>
                  <img
                    src={closeIcon}
                    alt="remove"
                    className="episodeListFilterObj-close-icon"
                    onClick={() =>
                      dispatch(updateFilters({ separation_date_from: null }))
                    }
                  />
                </Badge>
              )}

              {/* Separation Date To */}
              {filtersPayload.separation_date_to && (
                <Badge
                  bg="light"
                  text="dark"
                  className="episodeListFilterObj-breadcrumbItem"
                >
                  <span className="breadcrumb-text">
                    Seperation To Date :{" "}
                    {formatDDMMYYYY(filtersPayload.separation_date_to)}
                  </span>
                  <img
                    src={closeIcon}
                    alt="remove"
                    className="episodeListFilterObj-close-icon"
                    onClick={() =>
                      dispatch(updateFilters({ separation_date_to: null }))
                    }
                  />
                </Badge>
              )}

              {losOperator && (losValue || filtersPayload.no_los) && (
                <Badge
                  bg="light"
                  text="dark"
                  className="episodeListFilterObj-breadcrumbItem"
                >
                  <span className="breadcrumb-text">
                    Length of Stay :{" "}
                    {getLosBreadcrumbText(losOperator, losValue, losToValue)}
                  </span>
                  <img
                    src={closeIcon}
                    alt="remove"
                    className="episodeListFilterObj-close-icon"
                    onClick={() => {
                      setLosOperator("");
                      setLosValue("");
                      setLosToValue("");
                      setIsLosEnabled(false);
                      setLosMode("single");
                      dispatch(
                        updateFilters({
                          los: [],
                          no_los: false,
                          los_op: null,
                        }),
                      );
                    }}
                  />
                </Badge>
              )}

              {/* LOS Value */}
              {filtersPayload.los !== "" &&
                filtersPayload.los !== undefined && (
                  <Badge
                    bg="light"
                    text="dark"
                    className="episodeListFilterObj-breadcrumbItem"
                  >
                    <span className="breadcrumb-text">
                      {losMode === "range" ? "LOS From" : "LOS"} :
                      {getLabel("los", filtersPayload.los)}
                    </span>
                    <img
                      src={closeIcon}
                      alt="remove"
                      className="episodeListFilterObj-close-icon"
                      onClick={() => {
                        dispatch(updateFilters({ los: "" }));
                        // Also clear LOS To if in range mode
                        if (losMode === "range") {
                          dispatch(updateFilters({ los_to: "" }));
                          setLosMode("single");
                        }
                      }}
                    />
                  </Badge>
                )}

              {/* LOS To Value (for range mode) */}
              {losMode === "range" &&
                filtersPayload.los_to !== "" &&
                filtersPayload.los_to !== undefined && (
                  <Badge
                    bg="light"
                    text="dark"
                    className="episodeListFilterObj-breadcrumbItem"
                  >
                    <span className="breadcrumb-text">
                      LOS To : {getLabel("los_to", filtersPayload.los_to)}
                    </span>
                    <img
                      src={closeIcon}
                      alt="remove"
                      className="episodeListFilterObj-close-icon"
                      onClick={() => {
                        dispatch(updateFilters({ los_to: "" }));
                      }}
                    />
                  </Badge>
                )}
            </div>

            <Button className="episodelist-reset-btn" onClick={handleReset}>
              Clear All
            </Button>
          </div>
        )}

        {/* <div className="workflow-him-filter-container"> */}
        <div
          className="workflow-him-filter-container"
          style={{
            gridTemplateColumns:
              losMode === "range"
                ? "repeat(3, minmax(0, 1fr))"
                : "repeat(3, minmax(0, 1fr))",
          }}
        >
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Episode Identifier
            </label>

            <MultiSelect
              isMulti={true}
              options={episodeIdentiferFieldOptions}
              isLoading={episodeIdentiferFilterOptions.loading}
              hasMore={episodeIdentiferFilterOptions.hasMore}
              placeholder="Search episode identifer"
              onScrollBottom={handleScrollBottom(
                episodeIdentiferFilterOptions,
                getEpisodeIdentiferFilterOptions,
              )}
              onInputChange={handleInputChange(
                setEpisodeIdentiferFilterSearch,
                getEpisodeIdentiferFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  episodeIdentiferFilterOptions,
                  getEpisodeIdentiferFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur(
                "episodeIdentiferFilterOptions",
                setEpisodeIdentiferFilterSearch,
              )}
              onChange={(selected) => {
                handleOnChange({
                  key: "episode_identifier_search",
                  selected,
                  optionsState: episodeIdentiferFilterOptions,
                  fetchThunk: getEpisodeIdentiferFilterOptions,
                  searchResetAction: setEpisodeIdentiferFilterSearch,
                });
              }}
              value={episodeIdentiferFieldOptions?.filter((o) =>
                filtersPayload.episode_identifier_search?.includes(o?.value),
              )}
            />
          </div>

          {/* UR Number Section */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">MRN/UR</label>
            <MultiSelect
              isMulti={true}
              options={MRNFieldOptions}
              isLoading={MRNFilterOptions.loading}
              hasMore={MRNFilterOptions.hasMore}
              placeholder="Search MRN"
              onScrollBottom={handleScrollBottom(
                MRNFilterOptions,
                getMRNFilterOptions,
              )}
              onInputChange={handleInputChange(
                setMRNFilterSearch,
                getMRNFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(MRNFilterOptions, getMRNFilterOptions);
              }}
              onBlur={handleResetOnBlur("MRNFilterOptions", setMRNFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "medical_record_number",
                  selected,
                  optionsState: MRNFilterOptions,
                  fetchThunk: getMRNFilterOptions,
                  searchResetAction: setMRNFilterSearch,
                });
              }}
              // value={MRNFieldOptions.filter((o) =>
              //   filtersPayload.medical_record_number.includes(o.value),
              // )}
              value={MRNFieldOptions.filter((o) =>
                (Array.isArray(filtersPayload.medical_record_number)
                  ? filtersPayload.medical_record_number
                  : filtersPayload.medical_record_number
                    ? [filtersPayload.medical_record_number]
                    : []
                ).includes(o.value),
              )}
            />
          </div>

          {/* Other filter se-+ctions remain the same... */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Admission Date From
            </label>
            <DatePicker
              selected={
                filtersPayload.admission_date_from
                  ? new Date(filtersPayload.admission_date_from)
                  : null
              }
              onChange={(date) =>
                dispatch(
                  updateFilters({
                    admission_date_from: formatYYYYMMDD(date),
                    admission_date_to:
                      !date ||
                      (filtersPayload.admission_date_to &&
                        new Date(filtersPayload.admission_date_to) < date)
                        ? null
                        : filtersPayload.admission_date_to,
                  }),
                )
              }
              className="workflow-auditor-filter-date-picker"
              dateFormat="dd/MM/yyyy"
              placeholderText="Admission Date From"
              showMonthDropdown
              maxDate={new Date()}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
            />
          </div>
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Admission Date To
            </label>
            <div
              className={`${
                !filtersPayload.admission_date_from ? "datepicker-tooltip" : ""
              }`}
              data-title={
                "'To date' cannot be selected until 'Admission from date' is selected"
              }
            >
              <DatePicker
                selected={
                  filtersPayload.admission_date_to &&
                  filtersPayload.admission_date_from
                    ? new Date(filtersPayload.admission_date_to)
                    : null
                }
                onChange={(date) =>
                  dispatch(
                    updateFilters({ admission_date_to: formatYYYYMMDD(date) }),
                  )
                }
                className="workflow-auditor-filter-date-picker"
                dateFormat="dd/MM/yyyy"
                placeholderText="Admission Date To"
                disabled={!filtersPayload.admission_date_from}
                showMonthDropdown
                showYearDropdown
                maxDate={new Date()}
                dropdownMode="select"
                minDate={filtersPayload?.admission_date_from ?? null}
                onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
              />
            </div>
          </div>
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Separation Date From
            </label>
            <DatePicker
              selected={
                filtersPayload.separation_date_from
                  ? new Date(filtersPayload.separation_date_from)
                  : null
              }
              onChange={(date) =>
                dispatch(
                  updateFilters({
                    separation_date_from: formatYYYYMMDD(date),
                    separation_date_to:
                      !date ||
                      (filtersPayload.separation_date_to &&
                        new Date(filtersPayload.separation_date_to) < date)
                        ? null
                        : filtersPayload.separation_date_to,
                  }),
                )
              }
              className="workflow-auditor-filter-date-picker"
              dateFormat="dd/MM/yyyy"
              placeholderText="Separation Date From"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              maxDate={new Date()}
              minDate={
                filtersPayload?.admission_date_from ??
                filtersPayload?.admission_date_from
              }
              onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
            />
          </div>

          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Separation Date To
            </label>
            <div
              className={`${
                !filtersPayload.admission_date_from ? "datepicker-tooltip" : ""
              }`}
              data-title={
                "'To date' cannot be selected until 'Separation from date' is selected"
              }
            >
              <DatePicker
                selected={
                  filtersPayload.separation_date_to &&
                  filtersPayload.separation_date_from
                    ? new Date(filtersPayload.separation_date_to)
                    : null
                }
                onChange={(date) =>
                  dispatch(
                    updateFilters({ separation_date_to: formatYYYYMMDD(date) }),
                  )
                }
                className="workflow-auditor-filter-date-picker"
                dateFormat="dd/MM/yyyy"
                placeholderText="Separation Date To"
                disabled={!filtersPayload.separation_date_from}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={filtersPayload?.separation_date_from}
                maxDate={new Date()}
                onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
              />
            </div>
          </div>

          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Speciality</label>
            <MultiSelect
              isMulti={true}
              options={specialityFieldOptions}
              isLoading={specialityFilterOptions.loading}
              hasMore={specialityFilterOptions.hasMore}
              placeholder="Search speciality"
              onScrollBottom={handleScrollBottom(
                specialityFilterOptions,
                getSpecialityFilterOptions,
              )}
              onInputChange={handleInputChange(
                setSpecialityFilterSearch,
                getSpecialityFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  specialityFilterOptions,
                  getSpecialityFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur(
                "specialityFilterOptions",
                setSpecialityFilterSearch,
              )}
              onChange={(selected) => {
                handleOnChange({
                  key: "speciality",
                  selected,
                  optionsState: specialityFilterOptions,
                  fetchThunk: getSpecialityFilterOptions,
                  searchResetAction: setSpecialityFilterSearch,
                });
              }}
              value={specialityFieldOptions.filter((o) =>
                filtersPayload.speciality.includes(o.value),
              )}
            />
          </div>

          {/* Queue Filter */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Queue</label>
            {/* <QueueSelect /> */}
            <MultiSelect
              isMulti={true}
              options={queueFieldOptions}
              isLoading={queueFilterOptions.loading}
              hasMore={queueFilterOptions.hasMore}
              placeholder={
                isQueueDisabled
                  ? "Set User Specific to False to enable Queue"
                  : "Select Queue"
              }
              isDisabled={isQueueDisabled}
              onScrollBottom={handleScrollBottom(
                queueFilterOptions,
                getQueueFilterOptions,
              )}
              onInputChange={handleInputChange(
                setQueueFilterSearch,
                getQueueFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(queueFilterOptions, getQueueFilterOptions);
              }}
              onBlur={handleResetOnBlur(
                "queueFilterOptions",
                setQueueFilterSearch,
              )}
              onChange={(selected) => {
                handleOnChange({
                  key: "queue",
                  selected,
                  optionsState: queueFilterOptions,
                  fetchThunk: getQueueFilterOptions,
                  searchResetAction: setQueueFilterSearch,
                });
              }}
              value={queueFieldOptions.filter((o) =>
                filtersPayload.queue.includes(o.value),
              )}
            />
          </div>

          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">User Specific</label>
            {/* <UnassignedSelect /> */}
            <Select
              options={userSpecificOptions}
              value={userSpecificOptions.find(
                (o) => o.value === isUserSpecific,
              )}
              isSearchable={false}
              isClearable={false}
              onChange={(selected) => {
                const value = selected?.value ?? true;
                dispatch(
                  updateFilters({
                    is_user_specific: value,
                    ...(value === true && { queue: [] }),
                  }),
                );
              }}
            />
          </div>

          {/* Priority Filter */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Priority</label>
            {/* <PrioritySelect /> */}
            <MultiSelect
              isMulti={true}
              options={priorityFiledOptions}
              isLoading={priorityFilterOptions.loading}
              hasMore={priorityFilterOptions.hasMore}
              onScrollBottom={() => {
                if (
                  priorityFilterOptions.hasMore &&
                  !priorityFilterOptions.loading
                ) {
                  dispatch(
                    getPriorityFilterOptions({
                      queues: filtersPayload.queue || [],
                      search: priorityFilterOptions.search || "",
                      page_number: priorityFilterOptions.pageNumber + 1,
                      page_size: 10,
                    }),
                  );
                }
              }}
              placeholder={
                filtersPayload.queue.length === 0
                  ? "Select queue first"
                  : "Select priority"
              }
              isDisabled={filtersPayload.queue.length === 0}
              onInputChange={(value, { action }) => {
                if (action !== "input-change") return;
                dispatch(setPriorityFilterSearch(value));
                debounce((searchValue) => {
                  dispatch(
                    getPriorityFilterOptions({
                      queues: filtersPayload.queue || [],
                      search: searchValue || "",
                      page_number: 1,
                      page_size: 10,
                    }),
                  );
                }, 400)(value);
              }}
              onFocus={() => {
                if (
                  priorityFilterOptions?.data?.length === 0 &&
                  !priorityFilterOptions.loading
                ) {
                  dispatch(
                    getPriorityFilterOptions({
                      queues: filtersPayload.queue || [],
                      search: "",
                      page_number: 1,
                      page_size: 10,
                    }),
                  );
                }
              }}
              onBlur={() =>
                dispatch(
                  resetFilterByKey(
                    "priorityFilterOptions",
                    setPriorityFilterSearch,
                  ),
                )
              }
              onChange={(selected) => {
                handleOnChange({
                  key: "priority",
                  selected,
                  optionsState: priorityFilterOptions,
                  fetchThunk: getPriorityFilterOptions,
                  searchResetAction: setPriorityFilterSearch,
                });
              }}
              value={priorityFiledOptions.filter((o) =>
                filtersPayload?.priority?.includes(o?.value),
              )}
            />
            {filtersPayload.queue.length > 0 && (
              <div
                style={{
                  fontSize: "11px",
                  color: "#6b7280",
                  marginTop: "4px",
                }}
              >
                {priorityFilterOptions.data.length} priority options available
                {priorityFilterOptions.loading && " (loading...)"}
              </div>
            )}
          </div>

          <div className="workflow-him-filter-card flex flex-column">
            <div
              style={{
                marginTop: isUserSpecific === false ? "32px" : "0px",
              }}
            >
              <label className="workflow-him-filter-label">Status</label>
              <MultiSelect
                isMulti={true}
                options={filteredStatusOptions}
                isLoading={statusFilterOptions.loading}
                hasMore={statusFilterOptions.hasMore}
                placeholder="Search Status"
                onScrollBottom={handleScrollBottom(
                  statusFilterOptions,
                  getStatusFilterOptions,
                )}
                onInputChange={handleInputChange(
                  setStatusFilterSearch,
                  getStatusFilterOptions,
                )}
                onFocus={() => {
                  handleOnFocus(statusFilterOptions, getStatusFilterOptions);
                }}
                onBlur={handleResetOnBlur(
                  "statusFilterOptions",
                  setStatusFilterSearch,
                )}
                onChange={(selected) => {
                  handleOnChange({
                    key: "status",
                    selected,
                    optionsState: statusFilterOptions,
                    fetchThunk: getStatusFilterOptions,
                    searchResetAction: setStatusFilterSearch,
                  });
                }}
                value={filteredStatusOptions?.filter((o) =>
                  filtersPayload.status?.includes(o?.value),
                )}
              />
            </div>
            {isUserSpecific === false && (
              <small className="text-info">
                Set User Specific to true to see all the status
              </small>
            )}
          </div>

          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Health Fund Contract
            </label>

            <MultiSelect
              isMulti={true}
              options={healthFundFieldOptions}
              isLoading={healthFundContractFilterOptions.loading}
              hasMore={healthFundContractFilterOptions.hasMore}
              placeholder="Search Health Fund Contract"
              onScrollBottom={handleScrollBottom(
                healthFundContractFilterOptions,
                getHealthFundContractFilterOptions,
              )}
              onInputChange={handleInputChange(
                setHealthFundFilterContractSearch,
                getHealthFundContractFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  healthFundContractFilterOptions,
                  getHealthFundContractFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur(
                "healthFundContractFilterOptions",
                setHealthFundFilterContractSearch,
              )}
              onChange={(selected) => {
                handleOnChange({
                  key: "health_fund_contract",
                  selected,
                  optionsState: healthFundContractFilterOptions,
                  fetchThunk: getHealthFundContractFilterOptions,
                  searchResetAction: setHealthFundFilterContractSearch,
                });
              }}
              value={healthFundFieldOptions.filter((o) =>
                filtersPayload.health_fund_contract.includes(o.value),
              )}
            />
          </div>
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">LOS Operator</label>
            <Select
              className="los-operator"
              options={losOperatorOptions}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              maxMenuHeight={200}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                  ...base,
                  minHeight: "38px",
                  borderColor: "#cfd6e4",
                }),
              }}
              placeholder="Select operator"
              // value={losOperatorOptions.find((o) => o.value === losOperator)}
              value={
                losOperator
                  ? losOperatorOptions.find((o) => o.value === losOperator)
                  : null
              }
              onChange={handleLosOperatorChange}
            />
          </div>

          {/* Single LOS value */}
                    {!["gtlt", "gtelte"].includes(filtersPayload.los_op) && (
                      <div className="workflow-him-filter-card">
                        <label className="workflow-him-filter-label">
                          Length of Stay (LOS)
                        </label>
                        <div
                          className={`${
                            !filtersPayload.los_op ? "datepicker-tooltip" : ""
                          }`}
                          data-title={"Select LOS operator to enable"}
                        >
                          <input
                            type="number"
                            min="0"
                            className="workflow-him-filter-input"
                            value={filtersPayload.los?.[0] ?? ""}
                            disabled={!filtersPayload.los_op}
                            onKeyDown={(e) => {
                              if (e.key === "e" || e.key === "E") {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              const value = e.target.value;
                              dispatch(
                                updateFilters({
                                  los: value === "" ? [] : [Number(value)],
                                }),
                              );
                            }}
                            placeholder="Enter LOS"
                          />
                        </div>
                      </div>
                    )}
          
                    {/* LOS Range */}
                    {["gtlt", "gtelte"].includes(filtersPayload.los_op) && (
                      <>
                        <div className="workflow-him-filter-card">
                          <label className="workflow-him-filter-label">LOS From</label>
                          <input
                            type="number"
                            min="0"
                            className="workflow-him-filter-input"
                            value={filtersPayload.los?.[0] ?? ""}
                            onChange={(e) => {
                              const value = e.target.value;
          
                              dispatch(
                                updateFilters({
                                  los:
                                    value === ""
                                      ? []
                                      : [Number(value), filtersPayload.los?.[1]],
                                }),
                              );
                            }}
                            placeholder="From days"
                          />
                        </div>
          
                        <div className="workflow-him-filter-card">
                          <label className="workflow-him-filter-label">LOS To</label>
                          <input
                            type="number"
                            min="0"
                            className="workflow-him-filter-input"
                            value={filtersPayload.los?.[1] ?? ""}
                            onChange={(e) => {
                              const value = e.target.value;
          
                              dispatch(
                                updateFilters({
                                  los:
                                    filtersPayload.los?.[0] === undefined && value === ""
                                      ? []
                                      : [
                                          filtersPayload.los?.[0],
                                          value === "" ? undefined : Number(value),
                                        ],
                                }),
                              );
                            }}
                            placeholder="To days"
                          />
                        </div>
                      </>
                    )}

          {/* LOS Value - Enabled when operator is selected */}
          {/* <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              {losMode === "range" ? "LOS From" : "Length of Stay (LOS)"}
            </label>
            <div
              className={`${
                !filtersPayload.los_op ? "datepicker-tooltip" : ""
              }`}
              data-title={"Select LOS operator to enable"}
            >
              <LosSelect
                value={losValue}
                onChange={handleLosChange}
                placeholder={
                  losMode === "range" ? "Select minimum LOS" : "Select LOS"
                }
                isDisabled={!isLosEnabled}
              />
            </div>
          </div> */}

          {/* LOS To - Only shown in range mode */}
          {/* {losMode === "range" && (
            <div className="workflow-him-filter-card">
              <label className="workflow-him-filter-label">LOS To</label>
              <LosSelect
                value={losToValue}
                onChange={handleLosToChange}
                placeholder="Select maximum LOS"
                isDisabled={!isLosEnabled}
                isRangeTo={true}
              />
            </div>
          )} */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Provisional DRG</label>
            <MultiSelect
              isMulti={true}
              options={provisionalDrgFieldOptions}
              isLoading={provisionalDrgFilterOptions.loading}
              hasMore={provisionalDrgFilterOptions.hasMore}
              placeholder="Search DRG"
              onScrollBottom={handleScrollBottom(
                provisionalDrgFilterOptions,
                getProvisionalDrgFilterOptions,
              )}
              onInputChange={handleInputChange(
                setProvisionalDrgFilterSearch,
                getProvisionalDrgFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  provisionalDrgFilterOptions,
                  getProvisionalDrgFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur(
                "provisionalDrgFilterOptions",
                setProvisionalDrgFilterSearch,
              )}
              onChange={(selected) => {
                handleOnChange({
                  key: "drg_code",
                  selected,
                  optionsState: provisionalDrgFilterOptions,
                  fetchThunk: getProvisionalDrgFilterOptions,
                  searchResetAction: setProvisionalDrgFilterSearch,
                });
              }}
              value={provisionalDrgFieldOptions.filter((o) =>
                filtersPayload.drg_code.includes(o.value),
              )}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="episode-list-filter-modal-footer ">
        <Button
          className="el-filter-cancel btn btn-secondary"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          className="el-filter-submit btn btn-primary"
          onClick={handleApply}
        >
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AuditorFilterModal;
